import { SelectOption } from 'basics/options/options.types';
import { Currencies } from 'modules/maya/basics/enums/maya.enums';

const CurrenciesOptions: SelectOption[] = [
  { id: Currencies.USD, label: 'USD' },
  { id: Currencies.EUR, label: 'EUR' },
];

export default CurrenciesOptions;
